import { ButtonBase } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import IconPlus from 'src/assets/icons/Plus';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

export const NewToneOfVoiceCard = ({ className, onClick, disabled }) => {
  const styles = useStyles();

  return (
    <ButtonBase
      className={cx(styles.root, className)}
      onClick={onClick}
      disabled={disabled}
    >
      <CustomTypography
        variant={TYPOGRAPHY_VARIANT.medium14}
        color="primary"
        className={styles.title}
      >
        <IconPlus /> New tone of voice
      </CustomTypography>
      <CustomTypography
        variant={TYPOGRAPHY_VARIANT.paragraph12}
        align="left"
      >
        Select up to 5 traits: Formal, Friendly, Authentic, and more.
      </CustomTypography>
    </ButtonBase>
  );
};

NewToneOfVoiceCard.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
NewToneOfVoiceCard.defaultProps = {
  className: null,
  disabled: false,
};
